function text(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function directoryAssetMetadata(asset) {
  const value = asset?.metadataJson;
  if (value && typeof value === 'object' && !Array.isArray(value)) return value;
  if (typeof value !== 'string') return {};
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

// This is a presentation boundary, not a second identity reconciler. AssetId owns
// history; even duplicate immutable keys must remain visible for backend review.
export function directoryAssetIdentity(asset) {
  const metadata = directoryAssetMetadata(asset);
  const kind = text(metadata.directoryObjectType).toLowerCase();
  const domain = text(metadata.domainFqdn).toLowerCase();
  const guid = text(metadata.objectGuid || metadata.object_guid).toLowerCase();
  const sid = text(metadata.objectSid || metadata.object_sid).toUpperCase();
  const dn = text(metadata.distinguishedName || metadata.distinguished_name);
  const identityClaim = Object.keys(metadata).some(key => ['objectguid', 'object_guid', 'objectsid', 'object_sid'].includes(key.toLowerCase()));
  const provenance = text(metadata.source).toLowerCase() === 'ad-directory-inventory'
    || (Array.isArray(asset?.tags) && asset.tags.some(tag => text(tag).toLowerCase() === 'ad-directory-inventory'));
  if (!provenance && !identityClaim && !guid && !sid && !(domain && kind && dn)) return null;
  return {
    kind: kind || ({ 5: 'user', 2: 'computer', user: 'user', internalhost: 'computer' }[String(asset?.assetType).toLowerCase()] ?? 'directory'), domain, guid, sid, dn,
    // Never substitute DN/common name when a canonical ID is missing.
    key: text(asset?.assetId) ? JSON.stringify([text(asset?.clientId).toLowerCase(), text(asset.assetId).toLowerCase()]) : null,
  };
}
